module.exports = __webpack_public_path__ + "static/media/triangle.e2e65015.svg";